import { z } from 'zod';
import {
    NumberFormatting,
    getDefaults,
    MAX_INPUT_TEXT_LENGTH,
    MAX_READABLE_DECIMAL,
    Validation,
} from '@mews/framework';

export enum CashierCloseShiftKeys {
    Currencies = 'currencies',
    Notes = 'notes',
}

export const getCashierCloseShiftFormValidationSchema = (
    cashierCurrencies: string[],
    numberLocalizationInfo: NumberFormatting
) => {
    const amountValidation = Validation.Number.LocalizedNonNegativeNumber(numberLocalizationInfo)
        .pipe(
            z
                .number()
                .max(MAX_READABLE_DECIMAL)
                .transform((val) => val.toString())
        )
        .optional();
    const currencyValidationSchema = cashierCurrencies.reduce(
        (prev, next) => ({
            ...prev,
            [next]: amountValidation,
        }),
        {}
    ) as Record<string, z.ZodString>;

    return z.object({
        [CashierCloseShiftKeys.Currencies]: z.object(currencyValidationSchema),
        [CashierCloseShiftKeys.Notes]: z.string().max(MAX_INPUT_TEXT_LENGTH).optional(),
    });
};

export const getCashierCloseShiftFormDefaultValues = (
    cashierCurrencies: string[],
    numberLocalizationInfo: NumberFormatting
) =>
    getDefaults(
        getCashierCloseShiftFormValidationSchema(cashierCurrencies, numberLocalizationInfo)
    ) as CashierCloseShiftFormValues;

export type CashierCloseShiftFormValues = z.infer<ReturnType<typeof getCashierCloseShiftFormValidationSchema>>;
